import React from 'react';

export type LogoProps = React.SVGProps<SVGSVGElement> & {
  primary?: string; // replaces .st0 (#DB0032)
  secondary?: string; // replaces .st1 (#999999)
  ternary?: string; // replaces .st1 (#999999)
};

const AgenaLogo: React.FC<LogoProps> = ({
  primary = '#DB0032',
  secondary = '#999999',
  ternary = '#FFFFFF',
  ...props
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    viewBox='0 0 407.11 80.57'
    xmlSpace='preserve'
    enableBackground='new 0 0 407.11 80.57'
    aria-hidden='true'
    focusable='false'
    {...props}
  >
    <g>
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    fill={primary}
                    d='M73.97,50.94V31.72c-0.14-1.21-1.91-0.04-2.7,0.41l-3.65,2.11V52.7c-0.01,0.91,0.1,3.04-1.01,2.54
                      c0.66,0.33,1.46,0.31,2.11-0.05l4.11-2.31C73.54,52.48,73.97,51.74,73.97,50.94z'
                  />
                </g>
              </g>
            </g>
            <g>
              <g>
                <path
                  fill={ternary}
                  d='M65.85,51.52l0-4.17l-15.92-9.31c-0.79-0.46-2.68-1.39-1.7-2.12c-0.62,0.41-1.01,1.1-1.01,1.85v4.71
                    c0,0.8,0.43,1.53,1.13,1.93l16.49,9.65C65.95,54.56,65.84,52.43,65.85,51.52z'
                />
              </g>
            </g>
          </g>
          <g>
            <path
              fill={secondary}
              d='M51.7,36.86l3.61,2.11l15.96-9.21c0.79-0.45,2.56-1.62,2.69-0.41c-0.05-0.74-0.46-1.42-1.11-1.79
                l-4.07-2.37c-0.7-0.41-1.55-0.4-2.25,0.01L50,34.74C49.02,35.46,50.92,36.4,51.7,36.86z'
            />
          </g>
        </g>
      </g>
      <g>
        <path
          fill={primary}
          d='M92.94,28.66l-12.71,21.4h4.34l2.53-4.3h15.7l2.53,4.3h4.34l-12.71-21.4H92.94z M100.86,42.46H89.04
            l5.91-9.99L100.86,42.46z'
        />
        <path
          fill={primary}
          d='M118.58,50.29h11.35c5.4,0,7.41-2.18,7.41-8.03v-3.34h-14.23v3.3h10.43v1.53c0,2.27-1.17,3.24-3.92,3.24
            h-10.76c-3.02,0-4.25-1.1-4.25-3.8v-7.64c0-2.7,1.23-3.8,4.25-3.8H126c7.01,0,7.43,0.4,7.43,3.55v0.53h3.64v-1.26
            c0-4.06-2.72-6.12-8.09-6.12h-10.4c-5.52,0-7.78,2.36-7.78,8.14v5.56C110.81,47.93,113.06,50.29,118.58,50.29z'
        />
        <polygon
          fill={primary}
          points='144.96,40.7 161.51,40.7 161.51,37.4 144.96,37.4 144.96,31.96 162.19,31.96 162.19,28.66
            141.15,28.66 141.15,50.06 162.3,50.06 162.3,46.76 144.96,46.76'
        />
        <polygon
          fill={primary}
          points='169.07,32.9 186.97,50.06 191.81,50.06 191.81,28.66 188,28.66 188,45.83 170.1,28.66 165.26,28.66
            165.26,50.06 169.07,50.06'
        />
        <path
          fill={primary}
          d='M200.18,45.76h15.7l2.53,4.3h4.34l-12.71-21.4h-4.03l-12.71,21.4h4.34L200.18,45.76z M202.12,42.46l5.91-9.99
            l5.91,9.99H202.12z'
        />
        <path
          fill={ternary}
          d='M232.58,50.29h8.63c7.36,0,7.89-2.44,7.89-6.46c0-2.95-0.7-4.19-2.16-4.77c1.51-0.71,1.82-1.89,1.82-4.87
            c0-4.25-1.96-5.75-7.5-5.75h-10.09c-4.21,0-6.26,1.78-6.26,5.44v1.9h3.64V33.8c0-1.17,0.32-2.06,4.36-2.06h7.87
            c4.18,0,4.34,0.34,4.34,2.96c0,2.28,0,2.82-3.13,2.82h-8.31v3.3h9.01c2.12,0,2.76,0,2.76,3.02c0,3.1-0.1,3.16-5.4,3.16h-7.84
            c-3.64,0-3.8-0.84-3.8-3.77v-0.53h-3.64v1.82C224.78,48.72,226.89,50.29,232.58,50.29z'
        />
        <path
          fill={ternary}
          d='M259.11,50.29h9.67c5.34,0,7.52-2.12,7.52-7.33v-7.19c0-5.2-2.18-7.33-7.52-7.33h-9.67c-5.34,0-7.52,2.12-7.52,7.33v7.19
            C251.59,48.16,253.77,50.29,259.11,50.29z M255.22,41.67v-4.61c0-4.87,0.48-5.32,5.66-5.32h6.13c5.18,0,5.66,0.45,5.66,5.32v4.61
            c0,4.87-0.48,5.32-5.66,5.32h-6.13C255.7,46.99,255.22,46.54,255.22,41.67z'
        />
        <path
          fill={ternary}
          d='M295.87,28.44h-9.67c-5.34,0-7.52,2.12-7.52,7.33v7.19c0,5.2,2.18,7.33,7.52,7.33h9.67c5.34,0,7.52-2.12,7.52-7.33v-7.19
            C303.39,30.56,301.21,28.44,295.87,28.44z M299.75,37.06v4.61c0,4.87-0.48,5.32-5.66,5.32h-6.13c-5.18,0-5.66-0.45-5.66-5.32
            v-4.61c0-4.87,0.48-5.32,5.66-5.32h6.13C299.28,31.74,299.75,32.19,299.75,37.06z'
        />
        <path
          fill={ternary}
          d='M322.95,28.44h-9.67c-5.34,0-7.52,2.12-7.52,7.33v7.19c0,5.2,2.18,7.33,7.52,7.33h9.67c5.34,0,7.52-2.12,7.52-7.33v-7.19
            C330.48,30.56,328.3,28.44,322.95,28.44z M326.84,37.06v4.61c0,4.92-0.42,5.32-5.66,5.32h-6.13c-5.18,0-5.66-0.45-5.66-5.32v-4.61
            c0-4.87,0.48-5.32,5.66-5.32h6.13C326.42,31.74,326.84,32.14,326.84,37.06z'
        />
      </g>
    </g>
  </svg>
);

export default AgenaLogo;
